import { RoleType } from "ui/user/user.types";

export class AssignRoleRequestDto {
    userId: number;
    roleType: RoleType;
    organizationAddress: string;

    constructor(object: AssignRoleRequestDto) {
        this.userId = object.userId;
        this.roleType = object.roleType;
        this.organizationAddress = object.organizationAddress;
    }

    static create(object: AssignRoleRequestDto) {
        return new AssignRoleRequestDto(object);
    }
}
